export default {
  title: 'Configuración',
  reservation_hours_helper: 'Estas horas definen cuándo los clientes pueden hacer reservas en línea.',
  reservation_hours_alert:
    'Tus horas de reserva difieren de tu horario habitual. Los clientes solo pueden reservar durante las horas indicadas aquí.',
  activated: 'Reservas activas',
  deactivated: 'Reservas inactivas',
  buttons: {
    activate: 'Activar',
    deactivate: 'Desactivar',
  },
  error_messages: {
    no_google_place: {
      title: 'El restaurante no está conectado a ninguna ubicación de Google',
      description: 'Por favor, conecta el restaurante a una ubicación de Google',
    },
    toggle_failed: 'No se pudieron actualizar las reservas. Inténtalo de nuevo.',
  },
};
